import Vue from 'vue'
import Prefix from '@vuecmp/plugins/prefix'
import ENV from './getEnv'
import './form_validation'
import './viewport'
import './config'

Vue.use(Prefix, {
  prefix: 'dextra-mfv',
})

Vue.config.silent = !ENV.enableDebug
Vue.config.performance = ENV.enableDebug
Vue.config.productionTip = ENV.enableDebug

Vue.config.keyCodes = {
  esc: 27,
}
